import React from 'react';
import Layout from './layout';

const Lender: React.FC = () => {
    return (
        <Layout>

            <div data-aos="fade-up" data-aos-duration="1000">
            
                        <div className="row">
                            <div className="col-12">
                                <div className="page-title-box d-flex align-items-center justify-content-between">
                                    <div className="d-flex align-items-center gap-15">
                                    <h1 className="mb-0 text-xxl"> Lender <span className="text-accent"></span></h1>
                                            <div className="btn-group">
                                                <button type="button" className="btn btn-primary dropdown-toggle rate_checker" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Rate Calculator <i className="mdi mdi-chevron-down"></i></button>
                                                <div className="dropdown-menu">
                                                    <a className="dropdown-item" href="#">Polly Rate Checker</a>
                                                    <div className="dropdown-item multidropdown">Lender Price Rate Checker 
                                                        <ul>
                                                            <li>
                                                                <a href="#">275 BPS</a>
                                                            </li>
                                                            <li>
                                                                <a href="#">200 BPS</a>
                                                            </li>
                                                            <li>
                                                                <a href="#">0 BPS</a>
                                                            </li>
                                                            <li>
                                                                <a href="#">Account</a>
                                                            </li>
                                                            <li>
                                                                <a href="#">Powered by <strong>Lender Price</strong></a>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                    
                                                </div>
                                                
                                            </div>
                                    </div>

                                    <div className="page-title-right">
                                        <ol className="breadcrumb m-0">
                                            <li className="breadcrumb-item"><a href="javascript: void(0);">Home</a></li>
                                            <li className="breadcrumb-item active">Lender</li>
                                        </ol>
                                    </div>

                                </div>
                            </div>
                        </div>
                        
                        <div className="row processorCard">
                            <div className="col-lg-3">
                                <div className="process_box box_01">
                                    <div className="process_boxcircel">
                                        <img src="assets/images/processor/Layer_1.svg"/>
                                    </div>
                                    <div className="process_boxcright">
                                        <p>Total</p>
                                        <h4>130</h4>
                                    </div>
                                </div>
                            </div>
                            
                            <div className="col-lg-3">
                                <div className="process_box box_02">
                                    <div className="process_boxcircel">
                                        <img src="assets/images/processor/Layer_2.svg"/>
                                    </div>
                                    <div className="process_boxcright">
                                        <p>Online</p>
                                        <h4>84</h4>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-3">
                                <div className="process_box box_03">
                                    <div className="process_boxcircel">
                                        <img src="assets/images/processor/Layer_3.svg"/>
                                    </div>
                                    <div className="process_boxcright">
                                        <p>Favourite</p>
                                        <h4>4,335</h4>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-3">
                                <div className="process_box box_04">
                                    <div className="process_boxcircel">
                                        <img src="assets/images/processor/Layer_4.svg"/>
                                    </div>
                                    <div className="process_boxcright">
                                        <p>History</p>
                                        <h4>4,335</h4>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="processor_bg">
                            <div className="processor_search">
                                <div className="processor_searcharea">
                                    <input type="text" className="form-control" placeholder="Search"/>
                                    <span className="search_icon"><img src="assets/images/processor/search.svg"/></span>
                                </div>
                                <div className="processor_filter">
                                    <a className="right-bar-toggle" href="#">Filter <img src="assets/images/processor/filter.svg"/></a>
                                </div>
                            </div>
                            <div className="processor_listing lender_list">
                                <ul>
                                    <li>
                                        <div className="processor_listtop">
                                            <div className="live_btn"><span></span> Live</div>
                                            <div className="like_dislike">
                                                <a href="javascript:void(0);"><img src="assets/images/processor/like.svg"/></a>
                                                <span className="like_txt">30</span>
                                                <a href="javascript:void(0);"><img src="assets/images/processor/dislike.svg"/></a>
                                                <span className="dislike_txt">0</span>
                                                <a href="javascript:void(0);" className="favorite_icon border-0">favorite</a>
                                            </div>
                                        </div>
                                        <div className="processor_lisbottom">
                                            <div className="rocessor_listimgctrl">
                                                <div className="rocessor_listimg">
                                                    <img src="assets/images/lenda/01.png"/>
                                                    <span className="online_circel"></span>
                                                </div>
                                                
                                            </div>
                                            <div className="rocessor_listright">
                                                <h4>United Wholesale Mortgage, LLC</h4>
                                                <div className="rating"><img src="assets/images/processor/rating.png"/> (4.5/10)</div>
                                                {/* <div className="submit_filearea">
                                                    
                                                    <a href="javascript:void(0);" className="favorite_icon">favorite</a>
                                                </div> */}
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="processor_listtop">
                                            <div className="hour_ago">4 hours ago</div>
                                            <div className="like_dislike">
                                                <a href="javascript:void(0);"><img src="assets/images/processor/like.svg"/></a>
                                                <span className="like_txt">30</span>
                                                <a href="javascript:void(0);"><img src="assets/images/processor/dislike.svg"/></a>
                                                <span className="dislike_txt">0</span>
                                                <a href="javascript:void(0);" className="favorite_icon border-0">favorite</a>
                                            </div>
                                        </div>
                                        <div className="processor_lisbottom">
                                            <div className="rocessor_listimgctrl">
                                                <div className="rocessor_listimg">
                                                    <img src="assets/images/lenda/02.png"/>
                                                    <span className="offline_circel"></span>
                                                </div>
                                                
                                            </div>
                                            <div className="rocessor_listright">
                                                <h4>Equity Prime Mortgage LLC</h4>
                                                <div className="rating"><img src="assets/images/processor/rating.png"/> (4.5/10)</div>
                                                {/* <div className="submit_filearea">
                                                    
                                                    <a href="javascript:void(0);" className="favorite_icon">favorite</a>
                                                </div> */}
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="processor_listtop">
                                            <div className="hour_ago">8 hours ago</div>
                                            <div className="like_dislike">
                                                <a href="javascript:void(0);"><img src="assets/images/processor/like.svg"/></a>
                                                <span className="like_txt">30</span>
                                                <a href="javascript:void(0);"><img src="assets/images/processor/dislike.svg"/></a>
                                                <span className="dislike_txt">0</span>
                                                <a href="javascript:void(0);" className="favorite_icon border-0">favorite</a>
                                            </div>
                                        </div>
                                        <div className="processor_lisbottom">
                                            <div className="rocessor_listimgctrl">
                                                <div className="rocessor_listimg">
                                                    <img src="assets/images/lenda/03.png"/>
                                                    <span className="offline_circel"></span>
                                                </div>
                                                
                                            </div>
                                            <div className="rocessor_listright">
                                                <h4>MLB Mortgage</h4>
                                                <div className="rating"><img src="assets/images/processor/rating.png"/> (4.5/10)</div>
                                                {/* <div className="submit_filearea">
                                                    
                                                    <a href="javascript:void(0);" className="favorite_icon">favorite</a>
                                                </div> */}
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="processor_listtop">
                                            <div className="hour_ago">6 hours ago</div>
                                            <div className="like_dislike">
                                                <a href="javascript:void(0);"><img src="assets/images/processor/like.svg"/></a>
                                                <span className="like_txt">30</span>
                                                <a href="javascript:void(0);"><img src="assets/images/processor/dislike.svg"/></a>
                                                <span className="dislike_txt">0</span>
                                                <a href="javascript:void(0);" className="favorite_icon border-0">favorite</a>
                                                
                                            </div>
                                        </div>
                                        <div className="processor_lisbottom">
                                            <div className="rocessor_listimgctrl">
                                                <div className="rocessor_listimg">
                                                    <img src="assets/images/lenda/04.jpg"/>
                                                    <span className="offline_circel"></span>
                                                </div>
                                                
                                            </div>
                                            <div className="rocessor_listright">
                                                <h4>PennyMac Loan Services, LLC</h4>
                                                <div className="rating"><img src="assets/images/processor/rating.png"/> (4.5/10)</div>
                                                {/* <div className="submit_filearea">
                                                    
                                                    <a href="javascript:void(0);" className="favorite_icon">favorite</a>
                                                </div> */}
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="processor_listtop">
                                            <div className="hour_ago">1 hours ago</div>
                                            <div className="like_dislike">
                                                <a href="javascript:void(0);"><img src="assets/images/processor/like.svg"/></a>
                                                <span className="like_txt">30</span>
                                                <a href="javascript:void(0);"><img src="assets/images/processor/dislike.svg"/></a>
                                                <span className="dislike_txt">0</span>
                                                <a href="javascript:void(0);" className="favorite_icon border-0">favorite</a>
                                            </div>
                                        </div>
                                        <div className="processor_lisbottom">
                                            <div className="rocessor_listimgctrl">
                                                <div className="rocessor_listimg">
                                                    <img src="assets/images/lenda/05.png"/>
                                                    <span className="offline_circel"></span>
                                                </div>
                                                
                                            </div>
                                            <div className="rocessor_listright">
                                                <h4>11 Mortgage</h4>
                                                <div className="rating"><img src="assets/images/processor/rating.png"/> (4.5/10)</div>
                                                {/* <div className="submit_filearea">
                                                    
                                                    <a href="javascript:void(0);" className="favorite_icon">favorite</a>
                                                </div> */}
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="processor_listtop">
                                            <div className="hour_ago">3 hours ago</div>
                                            <div className="like_dislike">
                                                <a href="javascript:void(0);"><img src="assets/images/processor/like.svg"/></a>
                                                <span className="like_txt">30</span>
                                                <a href="javascript:void(0);"><img src="assets/images/processor/dislike.svg"/></a>
                                                <span className="dislike_txt">0</span>
                                                <a href="javascript:void(0);" className="favorite_icon border-0">favorite</a>
                                            </div>
                                        </div>
                                        <div className="processor_lisbottom">
                                            <div className="rocessor_listimgctrl">
                                                <div className="rocessor_listimg">
                                                    <img src="assets/images/lenda/06.png"/>
                                                    <span className="offline_circel"></span>
                                                </div>
                                                
                                            </div>
                                            <div className="rocessor_listright">
                                                <h4>HomeXpress Mortgage</h4>
                                                <div className="rating"><img src="assets/images/processor/rating.png"/> (4.5/10)</div>
                                                {/* <div className="submit_filearea">
                                                    
                                                    <a href="javascript:void(0);" className="favorite_icon">favorite</a>
                                                </div> */}
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="processor_listtop">
                                            <div className="hour_ago">4 hours ago</div>
                                            <div className="like_dislike">
                                                <a href="javascript:void(0);"><img src="assets/images/processor/like.svg"/></a>
                                                <span className="like_txt">30</span>
                                                <a href="javascript:void(0);"><img src="assets/images/processor/dislike.svg"/></a>
                                                <span className="dislike_txt">0</span>
                                                <a href="javascript:void(0);" className="favorite_icon border-0">favorite</a>
                                            </div>
                                        </div>
                                        <div className="processor_lisbottom">
                                            <div className="rocessor_listimgctrl">
                                                <div className="rocessor_listimg">
                                                    <img src="assets/images/lenda/07.png"/>
                                                    <span className="offline_circel"></span>
                                                </div>
                                                
                                            </div>
                                            <div className="rocessor_listright">
                                                <h4>Mega Capital Funding, Inc</h4>
                                                <div className="rating"><img src="assets/images/processor/rating.png"/> (4.5/10)</div>
                                                {/* <div className="submit_filearea">
                                                    
                                                    <a href="javascript:void(0);" className="favorite_icon">favorite</a>
                                                </div> */}
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="processor_listtop">
                                            <div className="hour_ago">3 hours ago</div>
                                            <div className="like_dislike">
                                                <a href="javascript:void(0);"><img src="assets/images/processor/like.svg"/></a>
                                                <span className="like_txt">30</span>
                                                <a href="javascript:void(0);"><img src="assets/images/processor/dislike.svg"/></a>
                                                <span className="dislike_txt">0</span>
                                                <a href="javascript:void(0);" className="favorite_icon border-0">favorite</a>
                                            </div>
                                        </div>
                                        <div className="processor_lisbottom">
                                            <div className="rocessor_listimgctrl">
                                                <div className="rocessor_listimg">
                                                    <img src="assets/images/lenda/08.png"/>
                                                    <span className="offline_circel"></span>
                                                </div>
                                                
                                            </div>
                                            <div className="rocessor_listright">
                                                <h4>KIND LENDING, LLC</h4>
                                                <div className="rating"><img src="assets/images/processor/rating.png"/> (4.5/10)</div>
                                                {/* <div className="submit_filearea">
                                                    
                                                    <a href="javascript:void(0);" className="favorite_icon">favorite</a>
                                                </div> */}
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="processor_listtop">
                                            <div className="hour_ago">1 hours ago</div>
                                            <div className="like_dislike">
                                                <a href="javascript:void(0);"><img src="assets/images/processor/like.svg"/></a>
                                                <span className="like_txt">30</span>
                                                <a href="javascript:void(0);"><img src="assets/images/processor/dislike.svg"/></a>
                                                <span className="dislike_txt">0</span>
                                                <a href="javascript:void(0);" className="favorite_icon border-0">favorite</a>
                                            </div>
                                        </div>
                                        <div className="processor_lisbottom">
                                            <div className="rocessor_listimgctrl">
                                                <div className="rocessor_listimg">
                                                    <img src="assets/images/lenda/09.png"/>
                                                    <span className="offline_circel"></span>
                                                </div>
                                                
                                            </div>
                                            <div className="rocessor_listright">
                                                <h4>Alaxi Sampson</h4>
                                                <div className="rating"><img src="assets/images/processor/rating.png"/> (4.5/10)</div>
                                                {/* <div className="submit_filearea">
                                                    
                                                    <a href="javascript:void(0);" className="favorite_icon">favorite</a>
                                                </div> */}
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="processor_listtop">
                                            <div className="hour_ago">4 hours ago</div>
                                            <div className="like_dislike">
                                                <a href="javascript:void(0);"><img src="assets/images/processor/like.svg"/></a>
                                                <span className="like_txt">30</span>
                                                <a href="javascript:void(0);"><img src="assets/images/processor/dislike.svg"/></a>
                                                <span className="dislike_txt">0</span>
                                                <a href="javascript:void(0);" className="favorite_icon border-0">favorite</a>
                                            </div>
                                        </div>
                                        <div className="processor_lisbottom">
                                            <div className="rocessor_listimgctrl">
                                                <div className="rocessor_listimg">
                                                    <img src="assets/images/lenda/10.png"/>
                                                    <span className="offline_circel"></span>
                                                </div>
                                                
                                            </div>
                                            <div className="rocessor_listright">
                                                <h4>Paramount Residential Mortgage Group, Inc</h4>
                                                <div className="rating"><img src="assets/images/processor/rating.png"/> (4.5/10)</div>
                                                {/* <div className="submit_filearea">
                                                    
                                                    <a href="javascript:void(0);" className="favorite_icon">favorite</a>
                                                </div> */}
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="processor_listtop">
                                            <div className="hour_ago">7 hours ago</div>
                                            <div className="like_dislike">
                                                <a href="javascript:void(0);"><img src="assets/images/processor/like.svg"/></a>
                                                <span className="like_txt">30</span>
                                                <a href="javascript:void(0);"><img src="assets/images/processor/dislike.svg"/></a>
                                                <span className="dislike_txt">0</span>
                                                <a href="javascript:void(0);" className="favorite_icon border-0">favorite</a>
                                            </div>
                                        </div>
                                        <div className="processor_lisbottom">
                                            <div className="rocessor_listimgctrl">
                                                <div className="rocessor_listimg">
                                                    <img src="assets/images/lenda/11.png"/>
                                                    <span className="offline_circel"></span>
                                                </div>
                                                
                                            </div>
                                            <div className="rocessor_listright">
                                                <h4>CMG Financial</h4>
                                                <div className="rating"><img src="assets/images/processor/rating.png"/> (4.5/10)</div>
                                                {/* <div className="submit_filearea">
                                                    
                                                    <a href="javascript:void(0);" className="favorite_icon">favorite</a>
                                                </div> */}
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="processor_listtop">
                                            <div className="hour_ago">4 hours ago</div>
                                            <div className="like_dislike">
                                                <a href="javascript:void(0);"><img src="assets/images/processor/like.svg"/></a>
                                                <span className="like_txt">30</span>
                                                <a href="javascript:void(0);"><img src="assets/images/processor/dislike.svg"/></a>
                                                <span className="dislike_txt">0</span>
                                                <a href="javascript:void(0);" className="favorite_icon border-0">favorite</a>
                                            </div>
                                        </div>
                                        <div className="processor_lisbottom">
                                            <div className="rocessor_listimgctrl">
                                                <div className="rocessor_listimg">
                                                    <img src="assets/images/lenda/12.png"/>
                                                    <span className="offline_circel"></span>
                                                </div>
                                                
                                            </div>
                                            <div className="rocessor_listright">
                                                <h4>REMN Wholesale </h4>
                                                <div className="rating"><img src="assets/images/processor/rating.png"/> (4.5/10)</div>
                                                {/* <div className="submit_filearea">
                                                    
                                                    <a href="javascript:void(0);" className="favorite_icon">favorite</a>
                                                </div> */}
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>

                         
            </div>

        </Layout>
    );
};

export default Lender;